export enum EnviromentEnum {
    HML = 'hml',
    PRD = 'prd',
}
